import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../../../../store/store.ts';
import { DoraFinancialEntity } from '../../models/doraFinancialEntity.ts';

interface DoraFinancialEntityState {
  doraFinancialEntities: DoraFinancialEntity[];
  selectedDoraFinancialEntity: DoraFinancialEntity | null;
}

const initialState: DoraFinancialEntityState = {
  doraFinancialEntities: [],
  selectedDoraFinancialEntity: null,
};

const doraFinancialEntitySlice = createSlice({
  name: 'doraFinancialEntity',
  initialState,
  reducers: {
    setDoraFinancialEntities(state, action: PayloadAction<DoraFinancialEntity[]>) {
      state.doraFinancialEntities = action.payload;
    },
    addDoraFinancialEntity(state, action: PayloadAction<DoraFinancialEntity>) {
      state.doraFinancialEntities.push(action.payload);
    },
    updateDoraFinancialEntity(state, action: PayloadAction<DoraFinancialEntity>) {
      const index = state.doraFinancialEntities.findIndex(entity => entity.id === action.payload.id);
      if (index !== -1) state.doraFinancialEntities[index] = action.payload;
    },
    removeDoraFinancialEntity(state, action: PayloadAction<number>) {
      state.doraFinancialEntities = state.doraFinancialEntities.filter(entity => entity.id !== action.payload);
    },
    setSelectedDoraFinancialEntity(state, action: PayloadAction<DoraFinancialEntity | null>) {
      state.selectedDoraFinancialEntity = action.payload;
    },
  },
});

export const {
  setDoraFinancialEntities,
  addDoraFinancialEntity,
  updateDoraFinancialEntity,
  removeDoraFinancialEntity,
  setSelectedDoraFinancialEntity,
} = doraFinancialEntitySlice.actions;

export const selectDoraFinancialEntities = (state: RootState) => state.doraFinancialEntity.doraFinancialEntities;
export const selectSelectedDoraFinancialEntity = (state: RootState) => state.doraFinancialEntity.selectedDoraFinancialEntity;

export default doraFinancialEntitySlice.reducer;
